<template>
  <div />
</template>

<script>
import { userManager } from "@/utils/identity";
import { ROUTE_NAMES } from "@/router/constants";
import { formatQueryError } from "@/utils/queryError";

export default {
  async mounted() {
    try {
      await userManager.signinRedirectCallback();
      await this.$router.replace({ name: ROUTE_NAMES.IDENTIFICATION });
    } catch (error) {
      this.$trackException({
        exception: error,
        properties: { source: "view/SignInCallback/mounted" }
      });
      await this.$router.replace({
        name: ROUTE_NAMES.LOGIN,
        query: formatQueryError(error)
      });
    }
  }
};
</script>
